module.exports = __webpack_public_path__ + "static/media/Magikarp_gaussian2.18eff43b.png";